import React from 'react';
import styles from './style.css';

class Report extends React.Component {
  render() {
    const pathnameSplit = this.props.location.pathname.split('/');
    const additionalClassName = pathnameSplit.slice(1).join('-');

    return (
      <div className={styles['container-full-nosub']} id="reports">
        <div className={`${styles.container} ${styles[additionalClassName]}`}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default Report;
